import grapesjs from 'grapesjs';
import loadBlocks from './blocks';

export default grapesjs.plugins.add('gjs-pdf-blocks-basic', (editor, opts = {}) => {
  const config = {
    blocks: [
      'column1',
      'column2',
      'column3',
      'column3-7',
      'text',
      'link',
      'image',
      'container',
    ],
    flexGrid: 0,
    stylePrefix: 'gjs-',
    addBasicStyle: true,
    name: 'basicComponents',
    category: 'Básicos',
    labelColumn1: 'Bloque',
    labelColumn2: 'Columna 2',
    labelColumn3: 'Columna 3',
    labelContainer: 'Enlace Contenedor',
    labelText: 'Texto',
    labelLink: 'Enlace',
    labelImage: 'Imagen',
    rowHeight: 75,
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
});
